import React, { useState } from 'react';
import './App.css';     
import UploadForm from './components/UploadForm';
import CalendarLinks from './components/CalendarLinks';

function App() {
  const [icsURL, setIcsURL] = useState('');
  const [googleCalendarURL, setGoogleCalendarURL] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);


  const handleUploadSuccess = (url, publicUrl) => {
    setIcsURL(url);
    setGoogleCalendarURL(publicUrl || '');
    setErrorMsg('');
  };


  const handleUploadError = (msg) => {
    setErrorMsg(msg);
  };

  const handleReset = () => {
    setIcsURL('');
    setGoogleCalendarURL('');
    setErrorMsg('');
  };

  return (
    <div className="app-shell">
      <header className="site-header">
        <a className="brand" href="/" aria-label="Cab2Cal home">
          <span className="brand-mark" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M7 3v3M17 3v3M4 9h16" />
              <rect x="3.5" y="4.5" width="17" height="16" rx="3" />
              <path d="m8 14 2.2 2.2L16 11" />
            </svg>
          </span>
          <span>Cab2Cal</span>
        </a>
      </header>

      <main>
        <section className="workspace" aria-label="Schedule converter">
          <div className="workspace-heading">
            <div>
              <h1>{icsURL ? 'Calendar ready' : 'Upload schedule'}</h1>
            </div>
          </div>

          {icsURL && !loading ? (
            <CalendarLinks
              icsURL={icsURL}
              googleCalendarURL={googleCalendarURL}
              onReset={handleReset}
            />
          ) : (
            <UploadForm
              onSuccess={handleUploadSuccess}
              onError={handleUploadError}
              setLoading={setLoading}
              loading={loading}
            />
          )}

          {errorMsg && (
            <div className="error-message" role="alert">
              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <circle cx="10" cy="10" r="8" />
                <path d="M10 6.5v4.25M10 13.8v.1" />
              </svg>
              <span>{errorMsg}</span>
            </div>
          )}
        </section>

      </main>
    </div>
  );
}

export default App;
